import { useEffect } from "react";

const ORIGIN = typeof window !== "undefined" ? window.location.origin : "https://joindealvest.com";

function setMeta(name, content, isOg = false) {
  if (!content) return;
  const attr = isOg ? "property" : "name";
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(url) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

function setStructuredData(id, json) {
  let el = document.getElementById(id);
  if (json === null) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.id = id;
    el.type = "application/ld+json";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(json);
}

export default function Seo({ title, description, path = "", image, type = "website", structuredData = null }) {
  useEffect(() => {
    const fullTitle = title?.includes("DealVest") ? title : `${title} | DealVest`;
    if (title) document.title = fullTitle;
    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, true);
      setMeta("twitter:description", description);
    }
    setMeta("og:title", fullTitle, true);
    setMeta("twitter:title", fullTitle);
    setMeta("og:url", `${ORIGIN}${path}`, true);
    setMeta("og:type", type, true);
    if (image) {
      setMeta("og:image", image, true);
      setMeta("twitter:image", image);
    }
    setCanonical(`${ORIGIN}${path}`);

    if (structuredData) setStructuredData("dv-page-jsonld", structuredData);
    else setStructuredData("dv-page-jsonld", null);

    return () => setStructuredData("dv-page-jsonld", null);
  }, [title, description, path, image, type, structuredData]);

  return null;
}
